<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="book-title" lang="en-US">Project Keepsake</p>
<p class="book-subtitle" lang="en-US">An Anthology</p>
<p class="book-author_print-only" lang="en-US">Edited by Amber Lanier Nagle</p>
<p> </p>
<p class="book-subtitle"><img alt="" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ProjectKeepsake59.vue?4437c810